<template>
  <v-card elevation="6" class="my-4 mx-4">
    <v-card-title class="mx-7 my-4" style="color:#AF8936">
      <h2>Actualizar Contraseña</h2>
      <div class="flex-grow-1"></div>
    </v-card-title>
    <v-form class="mx-10" ref="form" v-model="valid">
      <v-card flat>
        <v-toolbar color="grey" dark dense flat>
          <h3>{{ currentUser.nombre ? currentUser.nombre.toUpperCase() : '' }}</h3>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                :value="currentUser.nombre"
                label="Nombre"
                prepend-icon="mdi-account"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                :value="currentUser.email"
                label="Email"
                prepend-icon="mdi-email"
                readonly
                >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                :value="currentUser.email_contacto"
                label="Cargo"
                prepend-icon="mdi-account"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                :value="currentUser.fec_nacimiento"
                label="Fecha Nacimiento"
                prepend-icon="mdi-account"
                readonly
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-flex xs12>
            <v-checkbox
              v-model="changePassword"
              label="Cambiar Contraseña"
            ></v-checkbox>
          </v-flex>

          <template v-if="changePassword">
            <v-alert type="info" dense text class="mb-4 body-2">
              <strong>La nueva contraseña debe cumplir:</strong>
              <ul class="mt-1 pl-4" style="list-style: disc;">
                <li>Mínimo 8 caracteres</li>
                <li>Al menos una letra mayúscula</li>
                <li>Al menos una letra minúscula</li>
                <li>Al menos un número</li>
                <li>Al menos un carácter especial (!@#$%&*...)</li>
              </ul>
            </v-alert>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="pass.currentPassword"
                  :append-icon="showcurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  label="Contraseña Actual"
                  :type="showcurrentPassword ? 'text' : 'password'"
                  :rules="[rules.required]"
                  counter
                  @click:append="showcurrentPassword = !showcurrentPassword"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="pass.newPassword"
                  :append-icon="shownewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  label="Nueva Contraseña"
                  :type="shownewPassword ? 'text' : 'password'"
                  :rules="[rules.required, rules.minLength, rules.uppercase, rules.lowercase, rules.number, rules.special]"
                  counter
                  @click:append="shownewPassword = !shownewPassword"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="pass.newPassword_confirmation"
                  :append-icon="shownewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  label="Confirmar Nueva Contraseña"
                  :type="shownewPassword ? 'text' : 'password'"
                  :rules="[rules.required, rules.match]"
                  counter
                  @click:append="shownewPassword = !shownewPassword"
                ></v-text-field>
              </v-col>

              <v-divider></v-divider>
              <v-btn block color="primary" @click="cambiarPassword()" class="my-5" :disabled="!valid">
                Actualizar Contraseña
              </v-btn>
            </v-row>
          </template>
        </v-card-text>
      </v-card>
    </v-form>
    <br>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  const Swal = require('sweetalert2');

  export default {
    data: () => ({
      valid: false,
      changePassword:false,
      currentPassword: false,
      pass:{
        currentPassword:'',
        newPassword:'',
        newPassword_confirmation:'',
      },
      defaultData:{
        currentPassword:'',
        newPassword:'',
        newPassword_confirmation:'',
      },
      showcurrentPassword: '',
      shownewPassword: '',
      rules: {
        required: v => !!v || 'Campo requerido',
        minLength: v => (v && v.length >= 8) || 'Mínimo 8 caracteres',
        uppercase: v => /[A-Z]/.test(v) || 'Debe incluir al menos una mayúscula',
        lowercase: v => /[a-z]/.test(v) || 'Debe incluir al menos una minúscula',
        number: v => /[0-9]/.test(v) || 'Debe incluir al menos un número',
        special: v => /[^A-Za-z0-9]/.test(v) || 'Debe incluir al menos un carácter especial',
      },
    }),
    created() {
      this.$store.commit("SET_LAYOUT", "dashboard-layout");
    },
    computed: {
      ...mapGetters([
        "currentUser",
        "isLoggedIn"
      ]),
      rules() {
        return {
          required: v => !!v || 'Campo requerido',
          minLength: v => (v && v.length >= 8) || 'Mínimo 8 caracteres',
          uppercase: v => /[A-Z]/.test(v) || 'Debe incluir al menos una mayúscula',
          lowercase: v => /[a-z]/.test(v) || 'Debe incluir al menos una minúscula',
          number: v => /[0-9]/.test(v) || 'Debe incluir al menos un número',
          special: v => /[^A-Za-z0-9]/.test(v) || 'Debe incluir al menos un carácter especial',
          match: v => v === this.pass.newPassword || 'Las contraseñas no coinciden',
        }
      }
    },
    watch: {
      'pass.newPassword'() {
        if (this.$refs.form) this.$refs.form.validate();
      },
      'pass.newPassword_confirmation'() {
        if (this.$refs.form) this.$refs.form.validate();
      },
    },
    methods: {
      cambiarPassword(pass) {
        if (!this.$refs.form.validate()) return;

        // Validar coincidencia desde el front antes de enviar
        if (this.pass.newPassword !== this.pass.newPassword_confirmation) {
          Swal.fire({
            icon: 'error',
            title: 'Las contraseñas no coinciden',
            text: 'La nueva contraseña y la confirmación deben ser iguales.',
            confirmButtonText: "Aceptar"
          })
          return;
        }

        if (this.isLoggedIn) {
          this.$store.dispatch("ACTUALIZAR_PASSWORD", {data: this.pass, url: "/users/updatePassword"})
          .then((response) => {
            if(response.data.status == 'ok'){
              Swal.fire({
                icon: 'success',
                title: 'Se ha actualizado correctamente',
                confirmButtonText: "Aceptar"
              })
              this.reset();
            }
            if(response.data.status == 'notmatch'){
              Swal.fire({
                icon: 'error',
                title: 'La contraseña actual no coincide',
                confirmButtonText: "Aceptar"
              })
            }
          })
          .catch(err => {
            const errors = err.response && err.response.data && err.response.data.errors;
            if (errors) {
              const messages = Object.values(errors).flat().join('\n');
              Swal.fire({
                icon: 'error',
                title: 'Error de validación',
                text: messages,
                confirmButtonText: "Aceptar"
              })
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Error al actualizar contraseña',
                confirmButtonText: "Aceptar"
              })
            }
          });
        }
      },
      reset() {
        this.pass = Object.assign({}, this.defaultData)
        this.changePassword = false
      },
    }
  };
</script>
